import $ from "jquery";

$(function () {
    const $trackedElements = $('[data-event-name]');

    if ($trackedElements.length === 0) {
        return;
    }

    $trackedElements.on('click', function () {
        const $element = $(this);
        const eventName = $element.attr('data-event-name');

        const pageSlug = window.location.pathname.split('/').filter(Boolean).pop();

        if (!eventName) {
            return;
        }

        const dataToPush = {
            'event': eventName,
            'page_name': pageSlug || 'unknown'
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataToPush);
    });
});